import { createSlice } from '@reduxjs/toolkit'
import { notificationGroup } from 'pages/notification/constants'
import { notificationTypeOptions } from 'pages/notification/constants'

const initialState = {
  processing: false,
  success: '',
  loading: false,
  page: 0,
  scheduled: {
    data: [],
    loading: false,
    page: 0,
    totalPage: 0,
    error: '',
    hasNext: false,
    hasPrev: false,
  },
  product: {
    data: [],
    error: '',
    loading: false,
  },
  selectedTab: notificationTypeOptions[0],
  selectedGroup: notificationGroup[0],
  redirect: false,
  count: {
    value: undefined,
    deviceCount:undefined,
    loading: false,
  },
}

const notificationSlice = createSlice({
  name: 'notificationSlice',
  initialState: initialState,
  reducers: {
    broadcastNotification: () => { },
    tryFetchScheduledNotification: () => { },
    tryFetchBulkNotification: () => { },
    fetchProductListByIds: () => { },
    tryDeleteScheduledNotification: () => { },
    tryScheduleNotification: () => { },
    tryBroadCastMobileNotification: () => { },
    tryUpdateScheduleNotification: () => { },
    tryGetRecieverCount: () => { },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true
      state.success = ''
    },
    setSuccess: (state, action) => {
      state.success = action.payload
      state.processing = false
      state.redirect = true
    },
    setNotificationLoading: (state) => {
      state.scheduled.loading = true
      state.scheduled.error = ''
    },
    setNotification: (state, action) => {
      const { error, page, data, hasNext, hasPrev, totalPage } = action.payload
      if (error) {
        state.scheduled.error = error
      } else {
        state.scheduled.data = data
        state.scheduled.page = page ?? state.scheduled.page
        state.scheduled.hasNext = hasNext ?? state.scheduled.hasNext
        state.scheduled.hasPrev = hasPrev ?? state.scheduled.hasPrev
        state.scheduled.totalPage = totalPage ?? state.scheduled.totalPage
      }
      state.scheduled.loading = false
    },
    setProductList: (state, action) => {
      state.product.data = action.payload
      state.product.loading = false
    },
    setProductLoading: (state, action) => {
      state.product.loading = action.payload ?? true
      state.product.error = ''
    },
    setNotificationTab: (state, action) => {
      state.selectedTab = action.payload
    },
    setNotificationGroup: (state, action) => {
      state.selectedGroup = action.payload;
      state.scheduled.page = 1;
    },
    setRedirect: (state, action) => {
      state.redirect = action.payload ?? false
      state.product.data = []
      state.product.error = ''
      state.product.loading = false
    },
    setNotificationCount: (state, action) => {
      state.count.value = action?.payload?.receivers_count
      state.count.deviceCount = action?.payload?.devices_count
      state.count.loading = false
    },
    setNotificationCountLoading: (state, action) => {
      state.count.loading = action.payload ?? false
    },
    resetNotification:() => initialState,
  },
})

export const {
  setNotificationCount,
  setNotificationLoading,
  setProcessing,
  setSuccess,
  broadcastNotification,
  setNotification,
  setError,
  setRedirect,
  setNotificationCountLoading,
  tryFetchScheduledNotification,
  tryScheduleNotification,
  tryUpdateScheduleNotification,
  setProductLoading,
  setProductList,
  fetchProductListByIds,
  setNotificationTab,
  tryDeleteScheduledNotification,
  tryBroadCastMobileNotification,
  tryGetRecieverCount,
  tryFetchBulkNotification,
  setNotificationGroup,
  resetNotification
} = notificationSlice.actions
export default notificationSlice.reducer
